import { IImpact } from "@core/interfaces/imaking-an-impact";

export const urlRegex =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w-\._~:/?#[\]@!\$&'()*+,;=.]+$/;

export const IMPACT_POSTER_PLACEHOLDER: IImpact[] = [
    {
        img: '../../../assets/images/makingAnImpact/hispanicOwned.png',
        alt: 'Hispanic Owned Business in California',
        href: '/',
    },
    {
        img: '../../../assets/images/makingAnImpact/creatingJob.png',
        alt: 'Creating over 500,000 jobs in California',
        href: '/',
    },
    {
        img: '../../../assets/images/makingAnImpact/smallBusiness.png',
        alt: 'Small Business',
        href: '/',
    },
]

export const IMPACT_POSTER_GROUP_TWO_PLACEHOLDER: IImpact[] = [
    {
        img: '../../../assets/images/makingAnImpact/generatingBillion.png',
        alt: 'Generating over $100 Billion in Annual Revenue',
        href: '/',
    },
    {
        img: '../../../assets/images/makingAnImpact/BuyingPower.png',
        alt: 'Buying Power',
        href: '/',
    },
    {
        img: '../../../assets/images/makingAnImpact/hispanicsRepresent.png',
        alt: "Hispanics represent over 39% California's population",
        href: '/',
    },
]